import { createAction, props } from '@ngrx/store';
import {
    AccessVisibility,
    SystemEntity,
} from '@wdx/clmi/clmi-swagger-gen';

export const getVisibilityForId = createAction(
    '[Visibility] Get Visibility For Id',
    props<{
        entityType: SystemEntity;
        entityId: string;
    }>(),
);

export const getVisibilityForIdSuccess = createAction(
    '[Visibility] Get Visibility For Id Success',
    props<{
        entityType: SystemEntity;
        entityId: string;
        visibility: AccessVisibility[];
    }>(),
);

export const getVisibilityForIdFailure = createAction(
    '[Visibility] Get Visibility For Id Failure',
    props<{
        entityType: SystemEntity;
        entityId: string;
        error: Error;
    }>(),
);
